// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : load code from domain directories
// =============================================================================
// ---Third-party imports
import { size, entries, has, includes, dict } from 'ldash';
import now from 'performance-now';
import { delay } from 'redux-saga/effects';
// ---Framework imports
import log from 'uix/logging';
import { IMPORT_LOADER } from 'generated_domain_code';
// example loader
// const IMPORT_LOADER = (dname, load) => {
//   switch (dname) {
//     case 's2wp':
//       return load(import(/* webpackChunkName: 'domain.s2wp' */ 'domain/s2wp'), dname, now())
//   }
// }
export function* loadCodeForDomains(dnames) {
    let loaded = {};
    let promises = [];
    let load = (importPromise, name, ts)=>{
        // if it has a "then", it qualifies as a promise
        if (importPromise.then) {
            promises.push(importPromise.then((module)=>{
                try {
                    loaded[name] = module;
                    log.chunk('loaded dcode from %o [%d ms]', name, now() - ts);
                } catch (err) {
                    log.exception(`error fetching graphic chunk ${name} %O`, err);
                    loaded[name] = false;
                }
            }).catch((err)=>{
                log.error('load failure for graphic chunk %o %O', name, err);
                loaded[name] = false;
            }));
        } else {
            // already a module
            loaded[name] = importPromise;
        }
    };
    // load domain code
    for (let dname of dnames){
        IMPORT_LOADER(dname, load);
    }
    //~ log.debug('waiting for %o chunks', size(promises))
    while(size(loaded) < size(promises)){
        yield delay(5);
    }
    let loadedSucc = dict(entries(loaded).filter((e)=>e[1]));
    return loadedSucc;
}
